import actionTypes from '../constants/action-types';

const registerTool = (tool) => ({
  type: actionTypes.REGISTER_TOOL,
  payload: { tool },
});

export default registerTool;
